import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL + '/auth';

const register = (name, email, qualification, password) => {
  return axios.post(API_URL + '/register', {
    name,
    email,
    qualification,
    password
  });
};

const login = async (email, password) => {
  const response = await axios.post(API_URL + '/login', { email, password });

  if (response.data.access_token) {
    const token = response.data.access_token;
    const decodedToken = JSON.parse(atob(token.split('.')[1]));
    const expirationTime = decodedToken.exp * 1000; // JWT exp is in seconds, convert to ms

    const userData = {
      ...response.data,
      expirationTime
    };

    // console.log('User data before storing in localStorage:', userData);

    localStorage.setItem('user', JSON.stringify(userData));

    // console.log('Stored user data in localStorage:', localStorage.getItem('user'));

    setTimeout(() => {
      logout();
      window.location.reload(); // Optional: to redirect to login or refresh UI
    }, expirationTime - Date.now());
  }

  return response.data;
};


const logout = () => {
  localStorage.removeItem('user');
};

const getCurrentUser = () => {
  return JSON.parse(localStorage.getItem('user'));
};

const AuthService = {
  register,
  login,
  logout,
  getCurrentUser,

  // Add a method to check token expiration before any action
  checkTokenExpiration() {
    const user = this.getCurrentUser();
    if (user && user.expirationTime && user.expirationTime <= Date.now()) {
      this.logout();
      window.location.reload(); // Optional
    }
  }
};


export default AuthService;
